import React, { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { useParams } from 'react-router-dom';

import { GrupoExibicaoProps } from 'pages/cadastro/loja/types';

export const initialStep = 1;

export const initialListStep: GrupoExibicaoProps[] = [
    {
        idConfiguracaoPropriedadeGrupoExibicao: '1',
        dsConfiguracaoPropriedadeGrupoExibicao: 'Dados Básicos',
        nrSequencia: '1',
        fgReordena: false,
    },
];

export type MenuAsideContextData = {
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
    listStep: GrupoExibicaoProps[];
    setListStep: Dispatch<SetStateAction<GrupoExibicaoProps[]>>;
};

interface FormProviderProps {
    children?: ReactNode;
}

const FormContext = createContext<MenuAsideContextData>({} as MenuAsideContextData);

export function LojaColunasMenuAsideProvider({ children }: FormProviderProps): JSX.Element {
    const { id } = useParams();
    const [activeStep, setActiveStep] = useState<number>(initialStep);
    const [listStep, setListStep] = useState(initialListStep);

    // Define as steps definidas no método getIdsEnabled como não desabilitadas ao entrar em uma tela salva (com id).
    useEffect(() => {
        if (id) {
            setListStep((list) => list.map((step) => ({ ...step })));
        }
    }, [id]);

    const contextValue = useMemo(
        () => ({
            activeStep,
            setActiveStep,
            listStep,
            setListStep,
        }),
        [activeStep, listStep],
    );

    return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>;
}

export const useLojaColunasMenuAsideContext = (): MenuAsideContextData => useContext(FormContext);
